import React from "react";
import { Box, Chip, TextField } from "@mui/material";

interface OverviewEditorProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

/**
 * OverviewEditor — a small multiline textarea with a character counter chip.
 * Shows `{len}/{max}` and turns the counter red when over limit (FR-3.1, FR-3.3).
 */
const OverviewEditor: React.FC<OverviewEditorProps> = ({
  value,
  onChange,
  maxLength = 4000,
}) => {
  const len = value.length;
  const isOverLimit = len > maxLength;

  return (
    <Box>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        multiline
        minRows={4}
        maxRows={12}
        fullWidth
        placeholder="Enter overview narrative..."
        error={isOverLimit}
        helperText={
          isOverLimit
            ? `Exceeds the ${maxLength.toLocaleString()} character limit.`
            : undefined
        }
        inputProps={{ spellCheck: true }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
        <Chip
          size="small"
          label={`${len.toLocaleString()} / ${maxLength.toLocaleString()}`}
          color={isOverLimit ? "error" : "default"}
          variant="outlined"
          sx={{ fontSize: 11 }}
        />
      </Box>
    </Box>
  );
};

export default OverviewEditor;
